module.exports = __webpack_public_path__ + "static/media/zhanhuoBackground.00833535.jpg";